import { BinxMark } from "./binx-mark";

export function SiteHeaderMark() {
  return <BinxMark />;
}
